export const iconFontAwesomeArrowsArrowTrendUp = (
	<i className="fa-solid fa-arrow-trend-up"></i>
);
